import React, { useRef } from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import "../styles/OurTeam.css";
import MeetTheTeam from "./MeetTheTeam.jsx";
import Homebranches from "./HomeBranches.jsx";
import ClientLogos from "./ClientLogos.jsx";
import TeamExpertiseSection from "./TeamExpertiseSection.jsx";
import CompanyProfile from "./CompanyProfile.jsx";

const OurTeam = () => {
  const carouselRef = useRef(null);

  const scrollLeft = () => {
    if (carouselRef.current) {
      carouselRef.current.scrollBy({
        left: -carouselRef.current.offsetWidth,
        behavior: 'smooth',
      });
    }
  };

  const scrollRight = () => {
    if (carouselRef.current) {
      carouselRef.current.scrollBy({
        left: carouselRef.current.offsetWidth,
        behavior: 'smooth',
      });
    }
  };

  return (
    <>
    <Helmet>
        <title>Our Team | Dedicated Hospitality Experts | Laxmi Hospitality Services</title>
        <meta
          name="description"
          content="Meet the dedicated team behind Laxmi Hospitality Services. Passionate experts committed to delivering seamless catering solutions with care, flexibility, and quality for all your hospitality needs."
        />
        <meta name="robots" content="index, follow" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <link rel="canonical" href="https://laxmihospitalityservices.in/ourteam" />
      
        {/* -------- OPEN GRAPH (SOCIAL) -------- */}
        <meta property="og:type"        content="website" />
        <meta property="og:url"         content="https://laxmihospitalityservices.in/ourteam" />
        <meta property="og:title"       content="Our Team | Dedicated Hospitality Experts | Laxmi Hospitality Services" />
        <meta property="og:description" content="Meet the dedicated team behind Laxmi Hospitality Services. Passionate experts delivering seamless catering solutions across 5 states since 2009." />
        <meta property="og:site_name"   content="Laxmi Hospitality Services" />
        <meta property="og:locale"      content="en_IN" />
      
        {/* -------- TEAM STRUCTURED JSON LD DATA -------- */}
        <script type="application/ld+json">
        {`
          {
            "@context": "https://schema.org",
            "@type": "WebPage",
            "@id": "https://laxmihospitalityservices.in/ourteam",
            "name": "Our Team - Laxmi Hospitality Services",
            "description": "Meet our dedicated hospitality experts committed to delivering exceptional industrial catering solutions across India since 2009.",
            "url": "https://laxmihospitalityservices.in/ourteam",
            "about": { "@id": "https://laxmihospitalityservices.in/#organization" },
            "publisher": { "@id": "https://laxmihospitalityservices.in/#organization" },
            "sameAs": [
              "https://www.linkedin.com/company/laxmi-hospitality-services/",
              "https://www.instagram.com/laxmi_hospitality_services/"
            ],
            "inLanguage": "en-IN",
            "mainEntity": {
              "@type": "ItemList",
              "name": "Leadership Team",
              "description": "Key leadership and management team members at Laxmi Hospitality Services",
              "itemListElement": [
                {
                  "@type": "Person",
                  "name": "Mamata Sadanand Shetty",
                  "jobTitle": "Founder",
                  "worksFor": {
                    "@type": "Organization",
                    "@id": "https://laxmihospitalityservices.in/#organization"
                  }
                },
                {
                  "@type": "Person", 
                  "name": "Sadanand Shetty",
                  "jobTitle": "Co-Founder",
                  "worksFor": {
                    "@type": "Organization",
                    "@id": "https://laxmihospitalityservices.in/#organization"
                  }
                }
              ]
            }
          }
        `}
        </script>
      
        {/* -------- PAGE BREADCRUMB -------- */}
        <script type="application/ld+json">
        {`
          {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "@id": "https://laxmihospitalityservices.in/#breadcrumb",
            "name": "Website Breadcrumb",
            "itemListElement": [
              { "@type": "ListItem", "position": 1, "name": "Home",     "item": "https://laxmihospitalityservices.in/" },
              { "@type": "ListItem", "position": 2, "name": "Our Team", "item": "https://laxmihospitalityservices.in/ourteam" }
            ]
          }
        `}
        </script>
    </Helmet>

    <div className="page-container">
      <div className="hero-banner" role="img" aria-label="Our Team Banner">
        <img
          src="/images/Home-Page-Banner-4.png"
          alt="Our Team Banner Background"
          title="Our Team Banner Background"
          className="hero-image"
        />
        <div className="hero-overlay">
          <h1 className="hero-title">Our Team</h1>
          <p className="breadcrumb-nav">
            <Link to="/" className="breadcrumb-link">
              Home
            </Link>{" "}
            / Our Team
          </p>
        </div>
      </div>

      <TeamExpertiseSection />

      {/* NEW WRAPPER FOR CAROUSEL AND BUTTONS */}
      <div className="carousel-wrapper">
        <section className="image-carousel" ref={carouselRef}>
          <img
            src={process.env.PUBLIC_URL + "/images/Indian-canteen-buffet.png"         
            }
            alt="Food Collage 1"
          />
          <img
            src={
              process.env.PUBLIC_URL + "/images/Home-Page-Banner-3.jpg"
            }
            alt="Food Collage 2"
          />
          <img
            src={
              process.env.PUBLIC_URL + "/images/Home-Page-Banner-4.png"
            }
            alt="Food Collage 3"
          />
          <img
            src={
              process.env.PUBLIC_URL + "/copied images/image.png"
            }
            alt="Food Collage 4"
          />
          <img
            src={
              process.env.PUBLIC_URL + "/images/Home-Page-Banner-2.jpg"
            }
            alt="Food Collage 5"
          />    
          <img
            src={
              process.env.PUBLIC_URL + "/OurTeamSection-Carosel/image-carosel-7.jpg"
            }
            alt="Food Collage 6"
          />
           <img
            src={
              process.env.PUBLIC_URL + "/OurTeamSection-Carosel/image-carosel-3.jpg"
            }
            alt="Food Collage 7"
          />
          <img
            src={
              process.env.PUBLIC_URL + "/OurTeamSection-Carosel/image-carosel-1.jpg"
            }
            alt="Food Collage 8"
          />
        </section>
        <div className="carousel-control-button carousel-control-left" onClick={scrollLeft}>
          &#8592;
        </div>
        <div className="carousel-control-button carousel-control-right" onClick={scrollRight}>
          &#8594;
        </div>
      </div>

      <MeetTheTeam />
      <Homebranches />
      <CompanyProfile />
      <ClientLogos/>
    </div>
    </>
  );
};

export default OurTeam;